import mixpanel from 'mixpanel-browser'
import { FEATURES, REACT_APP_MIXPANEL_TOKEN } from 'config'
import isFeatureEnabled from 'utils/isFeatureEnabled'
import { onAnalyticsConsentChange } from 'consent-service'

const isMixpanelEnabled =
  !!REACT_APP_MIXPANEL_TOKEN && isFeatureEnabled(FEATURES.MIXPANEL)

let isInitialized = false

function initialize() {
  if (window.Cypress || !isMixpanelEnabled || isInitialized) return

  isInitialized = true
  mixpanel.init(REACT_APP_MIXPANEL_TOKEN, {
    track_pageview: 'url-with-path',
    persistence: 'localStorage',
  })
}

// `init` starts automatic pageview tracking, so it must wait for analytics
// consent. Withdrawal opts out, which also clears the SDK's stored identifiers.
onAnalyticsConsentChange((allowed) => {
  if (!allowed) {
    if (isInitialized) mixpanel.opt_out_tracking()
    return
  }

  initialize()
  // `track` defaults to sending an `$opt_in` event; there is nothing to record
  // here beyond re-enabling the SDK after a withdrawal.
  if (isInitialized) mixpanel.opt_in_tracking({ track: () => {} })
})

export default mixpanel
